// The phone layer's breakpoint (responsive.css).

import { useMediaQuery } from "./useMediaQuery";

export function useIsMobile(): boolean {
  return useMediaQuery("(max-width: 768px)");
}
